// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"style__modalTitle___1PUpg","modalContents":"style__modalContents___3xZ0S","buttonIcon":"style__buttonIcon___3zycs"};